import useModalTrigger from 'magik-react-hooks/useModalTrigger'
import { Link } from 'react-router-dom'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import Header from '../../components/Header'
import Page from '../../components/Page'
import Sorter, { SortControl } from '../../components/Sorter'
import StickyTable from '../../components/StickyTable'
import { useQsFilters } from '../../hooks/filters'
import { Testo } from '../../types'
import { useDeleteTesto, useTesti } from '../../hooks/testi'

const initFilters = (params: URLSearchParams) => ({
  page: Number(params.get('page') ?? 1),
  ordering: params.get('ordering') ?? '',
  search: params.get('search') ?? '',
})

export default function TestiList() {
  const { filters, uiFilters, setFilters, setFiltersDebounced } =
    useQsFilters(initFilters)
  const { data } = useTesti(filters)
  const deleteTesto = useDeleteTesto()
  const [modalRm, modalRmActions] = useModalTrigger<Testo>()

  return (
    <Page padded>
      <Header>
        <div className="d-flex align-items-end">
          <h2 className="m-0">Testi</h2>
        </div>
        <Link className="btn btn-primary" to="/testi/new">
          <i className="bi bi-plus-circle me-2"></i> Aggiungi
        </Link>
      </Header>
      <div className="d-flex justify-content-between mt-3 mb-3 align-items-center">
        <input
          placeholder="Cerca"
          className="form-control w-auto"
          type="text"
          value={uiFilters.search}
          onChange={(e) =>
            setFiltersDebounced({ search: e.target.value, page: 1 })
          }
        />
      </div>
      <StickyTable className="flex-1">
        <Sorter
          value={uiFilters.ordering}
          onSortChange={(ordering) =>
            setFilters({
              ordering,
              page: 1,
            })
          }
        >
          <thead>
            <tr>
              <th>
                <div className="d-flex align-items-center">
                  Slug
                  <SortControl field={'slug'} />
                </div>
              </th>
              <th>
                <div className="d-flex align-items-center">
                  Titolo
                  <SortControl field={'titolo'} />
                </div>
              </th>


              <th></th>
            </tr>
          </thead>
        </Sorter>
        <tbody>
          {data!.results.map((testo) => (
            <tr key={testo.id}>
              <td>{testo.slug}</td>
              <td>
                <Link to={`/testi/${testo.id}`}>{testo.titolo}</Link>
              </td>
              <td>
                <i
                  onClick={() => modalRmActions.open(testo)}
                  className="bi cursor-pointer text-danger bi-trash3-fill"
                ></i>
              </td>
            </tr>
          ))}
        </tbody>
      </StickyTable>
      <Modal centered isOpen={modalRm.isOpen} toggle={modalRmActions.toggle}>
        <ModalHeader toggle={modalRmActions.toggle}>Elimina</ModalHeader>
        <ModalBody>
          {modalRm.value && (
            <div className="pt-3 pb-3">
              Sei sicuro di voler eliminare il testo{' '} <strong>{modalRm.value.titolo}</strong>?
            </div>
          )}
        </ModalBody>
        <ModalFooter className="d-flex justify-content-between">
          <button
            onClick={modalRmActions.toggle}
            className="btn btn-outline-primary"
          >
            Annulla
          </button>
          <button
            className="btn  btn-danger"
            disabled={deleteTesto.isLoading}
            onClick={async () => {
              await deleteTesto.mutateAsync(modalRm.value!.id)
              modalRmActions.close()
            }}
          >
            <i className="bi bi-trash3-fill"></i> Elimina
          </button>
        </ModalFooter>
      </Modal>
      <div className="position-relative">

      </div>
    </Page>
  )
}
